<template>
	<svg :width="computedWidth" :height="computedHeight" viewBox="0 0 16 16" fill="none"
		xmlns="http://www.w3.org/2000/svg">
		<path
			d="M9.2 5.6H3.2C2.5382 5.6 2 6.1382 2 6.8V12.8C2 13.4618 2.5382 14 3.2 14H9.2C9.8618 14 10.4 13.4618 10.4 12.8V6.8C10.4 6.1382 9.8618 5.6 9.2 5.6Z"
			:fill="color_prop" />
		<path
			d="M12.8 2H6.8C6.48174 2 6.17652 2.12643 5.95147 2.35147C5.72643 2.57652 5.6 2.88174 5.6 3.2V4.4H10.4C10.7183 4.4 11.0235 4.52643 11.2485 4.75147C11.4736 4.97652 11.6 5.28174 11.6 5.6V10.4H12.8C13.1183 10.4 13.4235 10.2736 13.6485 10.0485C13.8736 9.82348 14 9.51826 14 9.2V3.2C14 2.88174 13.8736 2.57652 13.6485 2.35147C13.4235 2.12643 13.1183 2 12.8 2Z"
			:fill="color_prop" />
	</svg>


</template>

<script>
export default {

	name: 'IconRefresh',

	props: {
		sizeMultiplier_prop: {
			type: Number,
			default: 1,
		},

		width_prop: {
			type: String,
			default: '1rem',
		},

		height_prop: {
			type: String,
			default: '1rem',
		},

		color_prop: {
			type: String,
			default: '#007BFF',
		},
	},

	data() {
		return {
		}
	},

	computed: {

		// Computed Width & Height with multiplier
		computedWidth() {
			const { value, unit } = this.extractValueAndUnit(this.width_prop)
			return `${value * this.sizeMultiplier_prop}${unit}`
		},

		computedHeight() {
			const { value, unit } = this.extractValueAndUnit(this.height_prop)
			return `${value * this.sizeMultiplier_prop}${unit}`
		},
	},

	methods: {
		// extract value and unit from a string. px, em, rem, %
		extractValueAndUnit(input) {
			const regex = /^([\d.]+)(px|em|rem|%)$/ // Matches numeric values with units
			const match = input.match(regex)

			if (match) {
				const value = parseFloat(match[1]) // Convert numeric part to a number
				const unit = match[2] // Extract unit part
				return { value, unit }
			}

			return { value: 0, unit: 'px' } // Default value
		}
	}

}
</script>

<style lang="css" scoped></style>